(function () {
  function boot() {
    var header = document.querySelector('.chb-chrome');
    if (!header) return;
    var compact = false;
    var frame = 0;
    function measure() {
      document.documentElement.style.setProperty('--chb-header-height', header.getBoundingClientRect().height + 'px');
    }
    function update() {
      frame = 0;
      var next = compact ? window.scrollY > 100 : window.scrollY > 220;
      if (next !== compact) {
        compact = next;
        header.classList.toggle('chb-is-compact', compact);
      }
      measure();
    }
    window.addEventListener('scroll', function () { if (!frame) frame = requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', measure);
    if ('ResizeObserver' in window) new ResizeObserver(measure).observe(header);
    document.addEventListener('focusin', function (event) {
      if (event.target.closest('[data-search]')) {
        var mega = document.querySelector('[data-nav-mega]');
        var dim = document.querySelector('[data-nav-dim]');
        if (mega) mega.hidden = true;
        if (dim && !document.body.classList.contains('chb-nav-lock')) dim.hidden = true;
        document.querySelectorAll('.chb-nav-item[data-nav]').forEach(function (item) { item.setAttribute('aria-expanded', 'false'); item.classList.remove('is-active'); });
      }
    });
    update();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
